module.exports = __webpack_public_path__ + "assets/img/media_24.62b000e7.png";